export const utilsMixin = {
  methods: {
    $_utilsMixin_capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    $_utilsMixin_sortArray: function(property) {
      // sort an array of objects by property
      var sortOrder = 1;

      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }

      return function(a, b) {
        if (sortOrder === -1) {
          return b[property].localeCompare(a[property]);
        } else {
          return a[property].localeCompare(b[property]);
        }
      };
    },
    $_utilsMixin_showWarning: function(msg) {
      this.$vs.dialog({
        color: "warning",
        title: "Warning",
        text: msg
      });
    },
    $_utilsMixin_notify: function(title, msg, type) {
      const color = this._getMsgColor(type);
      this.$vs.notify({
        title: title,
        text: msg,
        color: color
      });
    },
    $_utilsMixin_getCategoryColor(value) {
      if (value < 0) {
        return "#C3C3C3";
      } else if (value < 0.1) {
        return "#a50026";
      } else if (value < 0.2) {
        return "#d73027";
      } else if (value < 0.3) {
        return "#f46d43";
      } else if (value < 0.4) {
        return "#fdae61";
      } else if (value < 0.5) {
        return "#fee08b";
      } else if (value < 0.6) {
        return "#d9ef8b";
      } else if (value < 0.7) {
        return "#a6d96a";
      } else if (value < 0.8) {
        return "#66bd63";
      } else if (value < 0.9) {
        return "#1a9850";
      }
      return "#006837";
    },
    $_utilsMixin_getCategoryIcon(value) {
      if (value < 0.4) {
        return "thumb_down";
      } else if (value < 0.7) {
        return "thumbs_up_down";
      }
      return "thumb_up";
    },
    _getMsgColor(type) {
      switch (type) {
        case 0:
          return "success";
        case 1:
          return "warning";
        case 2:
          return "danger";
        default:
          return "primary";
      }
    }
  }
};
